import { Node } from "@tiptap/core";

export const HelpcenterLinkExtension = Node.create({
  name: "helpCenterArticle",
  group: "block",
  atom: true,

  renderHTML({ HTMLAttributes }) {
    const { articleTitle, articleUrl, articleId } = HTMLAttributes;
    return [
      "a",
      {
        href: articleUrl,
        class: "helpcenter-article-link",
        target: "_blank",
        rel: "noopener noreferrer",
        "data-id": articleId,
      },
      // Include the provided SVG icon inline
      [
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 448 512",
          class: "helpcenter-article-icon",
        },
        [
          "path",
          {
            d: "M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm16 48l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z",
            fill: "currentColor",
          },
        ],
      ],
      // Then include the article title text
      articleTitle,
    ];
  },

  addAttributes() {
    return {
      articleId: {
        default: null,
      },
      articleTitle: {
        default: "No title",
      },
      articleDescription: {
        default: "No description",
      },
      articleUrl: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [
      {
        // Matching the anchor element with the specified class.
        tag: "a.helpcenter-article-link",
        getAttrs: (node) => {
          if (typeof node === "string" || node.nodeType !== 1) {
            return {};
          }
          const element = node as HTMLElement;
          return {
            articleId: element.getAttribute("data-id") || null,
            articleTitle: element.textContent || "No title",
            articleUrl: element.getAttribute("href") || null,
          };
        },
      },
    ];
  },

  renderText({ node }) {
    return node.attrs.articleTitle;
  },
});
